import React from 'react';
import Button from '../../../components/base/Button';

const HeroSection: React.FC = () => {
  const handleCTAClick = () => {
    const ctaSection = document.getElementById('cta');
    ctaSection?.scrollIntoView({ behavior: 'smooth' });
  };

  const handleExplanationClick = () => {
    document.querySelector('#vapi-widget-floating-button')?.click();
  };

  return (
    <section className="relative min-h-screen flex items-center justify-center pt-28 pb-16 bg-gradient-to-br from-blue-50 via-white to-teal-50">
      {/* 背景画像 */}
      <div 
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.2)), url('https://public.readdy.ai/ai/img_res/71054351325bdc11610a7cd6f84443c3.jpg')`
        }}
      />
      
      {/* オーバーレイ */}
      <div className="absolute inset-0 bg-black/20"></div>
      
      {/* コンテンツ */}
      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <div className="max-w-4xl mx-auto">
          {/* メインコピー */}
          <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight drop-shadow-lg" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8), -1px -1px 2px rgba(0,0,0,0.5)' }}>
            <span className="text-yellow-300 drop-shadow-lg" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8), -1px -1px 2px rgba(0,0,0,0.5)' }}>「正解はひとつじゃない」</span>
            <br />
            を学べる学校
          </h1>
          
          {/* サブコピー */}
          <p className="text-xl md:text-2xl lg:text-3xl text-white mb-8 font-medium drop-shadow-lg" style={{ textShadow: '2px 2px 4px rgba(0,0,0,0.8), -1px -1px 2px rgba(0,0,0,0.5)' }}>
            100人の生徒へ、100通り以上の未来を
          </p>
          
          {/* 説明文 */}
          <p className="text-lg md:text-xl text-white mb-10 max-w-3xl mx-auto leading-relaxed drop-shadow-lg" style={{ textShadow: '1px 1px 3px rgba(0,0,0,0.8), -1px -1px 2px rgba(0,0,0,0.5)' }}>
            従来の画一的な教育を変革し、一人ひとりの可能性を最大限に引き出す革新的な通信制高校。<br />
            あなたの個性と才能を活かした学びで、輝く未来を創り出すリーダーへと成長しませんか。
          </p>
          
          {/* CTAボタン */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <Button size="lg" onClick={handleCTAClick} className="min-w-48 shadow-lg">
              <i className="ri-arrow-right-line"></i>
              変革の輪に加わる
            </Button>
            <Button variant="outline" size="lg" className="min-w-48 bg-white/10 backdrop-blur-sm border-white/30 text-white hover:bg-white/20 shadow-lg">
              <i className="ri-play-circle-line"></i>
              学院紹介動画
            </Button>
          </div>
        </div>
        
        {/* スクロール指示 */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-bounce">
          <i className="ri-arrow-down-line text-2xl text-white drop-shadow-lg"></i>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;